<script lang="ts">
  import type { DerivedWorkout } from "../../lib/lapAnalysis";
  import { strokeColor, COLORS } from "../../lib/designTokens";
  import { fmtMSS } from "../../lib/format";

  interface Props { dw: DerivedWorkout }
  let { dw }: Props = $props();

  let totalSec = $derived(dw.laps.reduce((s, l) => s + l.durationSeconds, 0));
</script>

<article class="proto">
  <header>
    <span class="num">01</span>
    <h2>Stroke Ribbon</h2>
    <p class="story">The shape of your workout. Each segment is a length, color = stroke, width = time.</p>
  </header>

  <div class="ribbon">
    {#each dw.laps as lap (lap.index)}
      <div
        class="seg"
        style:flex-grow={lap.durationSeconds}
        style:background={lap.effectiveExcluded ? COLORS.textMuted : strokeColor(lap.strokeStyle)}
        style:opacity={lap.effectiveExcluded ? 0.4 : 1}
        title="Lap {lap.index} · {lap.strokeStyle} · {lap.durationSeconds.toFixed(1)}s{lap.effectiveExcluded ? ' · excluded' : ''}"
      ></div>
    {/each}
  </div>

  <div class="ruler">
    <span>0:00</span>
    <span class="mid">{fmtMSS(totalSec / 2)}</span>
    <span>{fmtMSS(totalSec)}</span>
  </div>

  <div class="sets">
    {#each dw.setGroups as s (s.index)}
      {@const firstLap = s.laps[0].index}
      {@const lastLap = s.laps[s.laps.length - 1].index}
      <div class="set">
        <span class="dot" style:background={strokeColor(s.laps[0]?.strokeStyle)}></span>
        <span class="set-label">
          <strong>{s.label}</strong>
          <span class="muted">×{s.laps.length}</span>
        </span>
        <span class="set-range muted">L{firstLap}{firstLap !== lastLap ? `–${lastLap}` : ""}</span>
        <span class="set-time">{fmtMSS(s.durationSeconds, "'")}"</span>
      </div>
    {/each}
  </div>
</article>

<style>
  .proto { background: var(--bg-card); border-radius: 12px; padding: 1rem; margin: 0.75rem 0; }
  header { margin-bottom: 1rem; }
  .num { display: inline-block; padding: 0.1rem 0.5rem; background: var(--accent-fire); color: var(--bg-canvas); font-size: 0.7rem; font-weight: 700; border-radius: 3px; letter-spacing: 1px; }
  h2 { font-size: 1.1rem; font-weight: 700; margin: 0.4rem 0 0.2rem; letter-spacing: -0.01em; }
  .story { font-size: 0.78rem; color: var(--text-muted); margin: 0; }

  .ribbon { display: flex; height: 36px; border-radius: 6px; overflow: hidden; gap: 1px; background: var(--bg-canvas); }
  .seg { min-width: 2px; transition: opacity 0.2s; }
  .seg:hover { opacity: 0.7; }

  .ruler { display: flex; justify-content: space-between; font-size: 0.65rem; color: var(--text-dim); margin: 0.3rem 0 1rem; font-variant-numeric: tabular-nums; }
  .ruler .mid { position: relative; }

  .sets { display: grid; grid-template-columns: auto 1fr auto auto; gap: 0.4rem 0.75rem; align-items: center; }
  .set { display: contents; }
  .dot { width: 10px; height: 10px; border-radius: 50%; }
  .set-label strong { font-size: 0.8rem; letter-spacing: 0.5px; }
  .set-label .muted { font-size: 0.75rem; margin-left: 0.3rem; }
  .set-range { font-size: 0.72rem; font-variant-numeric: tabular-nums; }
  .set-time { font-size: 0.8rem; font-variant-numeric: tabular-nums; font-weight: 600; }
  .muted { color: var(--text-muted); }
</style>
